export enum TimeTrackingTypes {
  FLEX=0,
  PARA=1,
  ACT48 = 2 // USED ONLY BY REPORTS FOR NOW
}